<script>
  import { page } from '@inertiajs/svelte'
  import { ArrowRight } from 'lucide-svelte'
  import AuthImage from '@assets/images/auth-image.webp'

  let isSignup = $derived($page.url.startsWith('/users'))
  let ctaText = $derived(isSignup ? 'Sign In Here' : 'Register Now')
  let ctaPath = $derived(isSignup ? '/session/new' : '/users/new')
</script>

<div class="flex-1 bg-primary-50 rounded-3xl flex flex-col overflow-hidden">
  <!-- Centered content group -->
  <div class="flex-1 flex flex-col items-center justify-center gap-5 px-10 py-8">
    <img src={AuthImage} alt="Altruist Wellbeing Forum" class="w-full object-contain" />
    <h2 class="text-3xl font-serif leading-tight text-center">The Altruist<br />Wellbeing Forum</h2>
    <p class="text-base text-gray-600 leading-relaxed text-center max-w-xs">
      A professional membership for HR teams and Wellbeing Champions. Join today for
      live sessions, practical ideas, expert resources, and peer support for busy roles.
    </p>
    {#if isSignup}
      <p class="text-sm text-gray-500">Already a member?</p>
    {/if}
    <a href={ctaPath} class="inline-flex items-center bg-white rounded-full border border-gray-900 pl-4 pr-1 py-2">
      <span class="text-gray-900 text-sm mr-2">{ctaText}</span>
      <div class="bg-sky-200 rounded-full p-1.5">
        <ArrowRight size={14} class="text-gray-900" />
      </div>
    </a>
  </div>

  <!-- Bottom link -->
  <a href="https://altruistuk.com" target="_blank" class="pb-9 text-center text-base text-gray-500 hover:text-gray-700">altruistuk.com</a>
</div>
